package org.bsvac.bsvac_kmp

sealed class MainUiState() {
    object Loading: MainUiState()
    class Loaded: MainUiState()

}
